/* src/app/location-users/add-location-users/add-location-users.component.scss */
.queue {
  width: 924px;
}
button {
  height: 36px;
  min-width: 190px;
  background-color: #00857D;
  border-radius: 100px;
  color: white;
  border: 0;
  white-space: nowrap;
}
.cancel-link {
  margin-left: 30px;
}
button:disabled {
  background-color: #E8E8E6 !important;
  color: #BEBEBE !important;
  border: none !important;
}
.error-message {
  color: #C91913;
  font-weight: 500;
  font-size: 16px;
  margin-top: 30px;
}
.error-message::before {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
}
.add-new-users-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 922px;
}
.add-new-users-subheader .template-link::after {
  font-family: "upsicons", fantasy !important;
  content: "\e634";
  margin: 0.25em;
}
input[type=file] {
  display: none;
}
.import-users-button {
  position: relative;
  height: 36px;
  min-width: 190px;
  background-color: white;
  border-radius: 100px;
  color: #00857D;
  border: 1px solid #00857D;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  line-height: 2rem;
  margin: 0;
}
.import-users-button.disabled {
  cursor: default;
  background-color: #D9D9D6;
  border: none;
  color: #757575;
  pointer-events: none;
}
.import-users-button-text::before {
  font-family: upsicons, fantasy;
  content: "\e634";
  padding-right: 0.5rem;
}
/*# sourceMappingURL=add-location-users.component.css.map */
